// Critical JavaScript for Xperiate Theme

// Theme initialization
document.addEventListener('DOMContentLoaded', function() {
  console.log('Xperiate theme loaded');

  // Initialize theme features
  initLazyLoading();
  initSmoothScroll();
  initHeaderScroll();
  initAnnouncement();
  initHeaderInteractions();
  initQuickView();
  initProductVariantSelector();
  initColorSwatches();
});

// Lazy loading for images
function initLazyLoading() {
  if ('IntersectionObserver' in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');

    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    });

    lazyImages.forEach(img => imageObserver.observe(img));
  }
}

// Smooth scroll for anchor links
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

// Header scroll effect
function initHeaderScroll() {
  const header = document.querySelector('header');
  if (!header) return;

  let lastScroll = 0;
  const scrollThreshold = 100;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > scrollThreshold) {
      header.classList.add('scrolled');

      // Hide header on scroll down, show on scroll up
      if (currentScroll > lastScroll && currentScroll > 200) {
        header.classList.add('hidden');
      } else {
        header.classList.remove('hidden');
      }
    } else {
      header.classList.remove('scrolled');
      header.classList.remove('hidden');
    }

    lastScroll = currentScroll;
  });
}

// Announcement bar close functionality
function initAnnouncement() {
  const announcementBar = document.querySelector('.announcement-bar');
  const closeBtn = document.querySelector('.announcement-close');

  if (announcementBar && closeBtn) {
    // Check if user has closed the announcement
    const announcementClosed = localStorage.getItem('announcement-closed');
    if (announcementClosed) {
      announcementBar.style.display = 'none';
    }

    closeBtn.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      localStorage.setItem('announcement-closed', 'true');
    });
  }
}

// Header interactions (mobile menu & search modal)
function initHeaderInteractions() {
  const mobileMenu = document.getElementById('mobileMenu');
  const searchModal = document.getElementById('searchModal');
  const searchInput = document.getElementById('searchInput');
  let mobileMenuHideTimer;
  let searchHideTimer;

  const setHiddenState = (element, isHidden) => {
    if (!element) return;
    element.hidden = isHidden;
    element.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
  };

  const openMobileMenu = () => {
    if (!mobileMenu) return;
    if (mobileMenuHideTimer) clearTimeout(mobileMenuHideTimer);
    setHiddenState(mobileMenu, false);
    requestAnimationFrame(() => mobileMenu.classList.add('active'));
    document.body.classList.add('mobile-menu-open');
  };

  const closeMobileMenu = () => {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('active');
    document.body.classList.remove('mobile-menu-open');
    mobileMenuHideTimer = setTimeout(() => setHiddenState(mobileMenu, true), 300);
  };

  function toggleMobileMenuHandler() {
    if (!mobileMenu) return;
    const shouldOpen = mobileMenu.hidden || !mobileMenu.classList.contains('active');
    if (shouldOpen) {
      openMobileMenu();
    } else {
      closeMobileMenu();
    }
  }

  const openSearchHandler = () => {
    if (!searchModal) return;
    if (searchHideTimer) clearTimeout(searchHideTimer);
    setHiddenState(searchModal, false);
    requestAnimationFrame(() => searchModal.classList.add('active'));
    document.body.classList.add('search-open');
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 100);
    }
  };

  const closeSearchHandler = () => {
    if (!searchModal) return;
    searchModal.classList.remove('active');
    document.body.classList.remove('search-open');
    searchHideTimer = setTimeout(() => setHiddenState(searchModal, true), 300);
  };

  window.toggleMobileMenu = toggleMobileMenuHandler;
  window.openSearch = openSearchHandler;
  window.closeSearch = closeSearchHandler;

  if (searchModal) {
    searchModal.addEventListener('click', (event) => {
      if (event.target === searchModal) {
        closeSearchHandler();
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSearchHandler();
      if (mobileMenu && mobileMenu.classList.contains('active')) {
        closeMobileMenu();
      }
    }
  });
}

// Add to cart functionality
function addToCart(variantId, quantity = 1, properties = {}) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: properties
    })
  })
  .then(response => response.json())
  .catch(error => {
    console.error('Error adding to cart:', error);
    throw error;
  });
}

// Update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    })
    .catch(error => console.error('Error updating cart count:', error));
}

// Show notification
function showNotification(message, type = 'success') {
  const notification = document.createElement('div');
  notification.className = `notification notification-${type}`;
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${type === 'success' ? '#10b981' : '#ef4444'};
    color: white;
    padding: 1rem 1.5rem;
    border-radius: 0.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 999999;
    animation: slideInRight 0.3s ease-out;
  `;

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.style.animation = 'slideOutRight 0.3s ease-out';
    setTimeout(() => notification.remove(), 300);
  }, 3000);
}

// Debounce function for performance
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Quick View functionality
function initQuickView() {
  const quickViewButtons = document.querySelectorAll('.quick-view-btn');
  quickViewButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const productHandle = button.dataset.productHandle;
      if (productHandle) {
        openQuickView(productHandle);
      }
    });
  });

  // Close modal when clicking outside
    const modal = document.getElementById('quickViewModal');
    if(modal) {
        modal.addEventListener('click', function(e) {
            if (e.target === this) {
                closeQuickView();
            }
        });
    }
}

function openQuickView(productHandle) {
  const modal = document.getElementById('quickViewModal');
  const content = document.getElementById('quickViewContent');
  if (!modal || !content) return;

  content.innerHTML = '<p>Loading...</p>';
  modal.style.display = 'flex';

  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      const productHtml = `
        <div class="quick-view-product" style="display: flex; gap: 2rem;">
          <div class="quick-view-image" style="flex: 1;">
            <img src="${product.featured_image}" alt="${product.title}" style="max-width: 100%; border-radius: 0.5rem;">
          </div>
          <div class="quick-view-details" style="flex: 1;">
            <h2>${product.title}</h2>
            <div class="quick-view-price" style="margin-bottom: 1rem; font-size: 1.25rem;">
                ${product.compare_at_price > product.price ? `<span class="price-sale" style="color: #ef4444; margin-right: 0.5rem;">${(product.price / 100).toFixed(2)}</span><span class="price-compare" style="text-decoration: line-through; color: #6b7280;">${(product.compare_at_price / 100).toFixed(2)}</span>` : `<span class="price-regular">${(product.price / 100).toFixed(2)}</span>`}
            </div>
            <form action="/cart/add" method="post" class="quick-view-form">
              <input type="hidden" name="id" value="${product.variants[0].id}">
              <button type="submit" class="btn btn-primary" style="margin-bottom: 1rem;">Add to Cart</button>
            </form>
            <div style="line-height: 1.6;">${product.description}</div>
            <a href="${product.url}" style="display: block; margin-top: 1rem; color: var(--color-primary);">View full details</a>
          </div>
        </div>
      `;
      content.innerHTML = productHtml;

        // Re-run addToCart for the new form
        const form = content.querySelector('.quick-view-form');
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const variantId = form.querySelector('input[name="id"]').value;
            XperiateTheme.addToCart(variantId)
                .then(() => {
                    XperiateTheme.updateCartCount();
                    XperiateTheme.showNotification('Added to cart!');
                    closeQuickView();
                })
                .catch(() => {
                    XperiateTheme.showNotification('Could not add to cart.', 'error');
                });
        });
    })
    .catch(error => {
      console.error('Error fetching product for quick view:', error);
      content.innerHTML = '<p>Sorry, there was an error loading this product.</p>';
    });
}

function closeQuickView() {
  const modal = document.getElementById('quickViewModal');
  if (modal) {
    modal.style.display = 'none';
  }
}

// Product Variant Selector
function initProductVariantSelector() {
    const productForm = document.querySelector('.product-page form[action="/cart/add"]');
    if (!productForm) return;

    const variantsJson = document.getElementById('productVariantsJson');
    if (!variantsJson) return;

    const variants = JSON.parse(variantsJson.textContent);

    productForm.addEventListener('change', (e) => {
        if (e.target.name.includes('options')) {
            const selectedOptions = Array.from(productForm.querySelectorAll('input[type="radio"]:checked')).map(input => input.value);
            const selectedVariant = variants.find(variant => {
                const variantOptions = [variant.option1, variant.option2, variant.option3].filter(Boolean);
                if (selectedOptions.length !== variantOptions.length) return false;
                
                const sortedSelected = [...selectedOptions].sort();
                const sortedVariant = [...variantOptions].sort();

                return sortedSelected.every((opt, index) => opt === sortedVariant[index]);
            });

            if (selectedVariant) {
                updateProductInfo(selectedVariant);
            }
        }
    });
}

function updateProductInfo(variant) {
    const mainImage = document.getElementById('mainProductImage');
    if (mainImage && variant.featured_image) {
        mainImage.src = variant.featured_image.src;
    }

    const priceElement = document.querySelector('.product-detail-price');
    if (priceElement) {
        const salePrice = `<span class="price-sale">${(variant.price / 100).toFixed(2)}</span>`;
        const comparePrice = variant.compare_at_price > variant.price ? `<span class="price-compare">${(variant.compare_at_price / 100).toFixed(2)}</span>` : '';
        const savePrice = variant.compare_at_price > variant.price ? `<span class="price-save">Save ${( (variant.compare_at_price - variant.price) / 100).toFixed(2)}</span>` : '';
        const regularPrice = `<span class="price-regular">${(variant.price / 100).toFixed(2)}</span>`;
        
        if (variant.compare_at_price > variant.price) {
            priceElement.innerHTML = `${salePrice} ${comparePrice} ${savePrice}`;
        } else {
            priceElement.innerHTML = regularPrice;
        }
    }

    const addToCartButton = document.querySelector('.add-to-cart-btn');
    if (addToCartButton) {
        if (variant.available) {
            addToCartButton.disabled = false;
            addToCartButton.innerHTML = `Add to Cart - ${(variant.price / 100).toFixed(2)}`;
        } else {
            addToCartButton.disabled = true;
            addToCartButton.innerHTML = 'Sold Out';
        }
    }

    const variantIdInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
    if(variantIdInput) {
        variantIdInput.value = variant.id;
    } else {
        // if the input is not there, create it
        const form = document.querySelector('form[action="/cart/add"]');
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'id';
        hiddenInput.value = variant.id;
        form.prepend(hiddenInput);
    }
}

// Color Swatch functionality
function initColorSwatches() {
    const swatchContainers = document.querySelectorAll('.color-swatches');
    swatchContainers.forEach(container => {
        container.addEventListener('click', (e) => {
            if (e.target.classList.contains('color-swatch')) {
                e.preventDefault();
                e.stopPropagation();
                
                const imageUrl = e.target.dataset.image;
                if (!imageUrl || imageUrl === 'null') return;
                
                const productId = container.dataset.productId;
                const productImage = document.querySelector(`.product-card-image-${productId}`);
                
                if (productImage) {
                    productImage.src = imageUrl;
                }
            }
        });
    });
}

// Add animation styles
const style = document.createElement('style');
style.textContent = `
  @keyframes slideInRight {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes slideOutRight {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

// Export functions for use in other scripts
window.XperiateTheme = {
  addToCart,
  updateCartCount,
  showNotification,
  debounce,
  closeQuickView
};
